import { IErrMsg } from '../../components/inputs/types'
import Decimal from 'decimal.js'
import { normalizeDecimal } from '../../validators/inputValidators/utils/getNumberSchema'

export const numberInputErrors = (
    state: any,
    schema: any
): IErrMsg | undefined => {
    if (schema.type === 'double' || schema.type === 'duration') {
        return doubleErrors(state, schema)
    }
    if (schema.type === 'number') {
        return numberErrors(state, schema)
    }
}

const numberErrors = (state: string, schema: any): IErrMsg | undefined => {
    if (!schema.is_required && (state === null || state === undefined)) {
        return
    }
    if (state && !String(state).match(/^(-)?\d+(\.\d+)?$/)) {
        return { message: 'errors.validation.invalidValue' }
    }
    if (schema.is_required && !state) {
        return { message: 'errors.validation.validValueRequired' }
    }
    if (
        String(state).startsWith('-') &&
        String(state).split('.').join()?.length > 30
    ) {
        return { message: 'errors.validation.invalidValue' }
    }
    if (String(state).split('.')[1]?.length > 28) {
        return { message: 'errors.validation.invalidValue' }
    }
    if (
        typeof schema.greater_or_equal !== 'undefined' &&
        !new Decimal(normalizeDecimal(state)).gte(
            new Decimal(schema.greater_or_equal)
        )
    ) {
        return {
            message: 'errors.validation.greaterOrEqual',
            values: { greaterOrEqual: schema.greater_or_equal },
        }
    }
    if (
        typeof schema.greater_than !== 'undefined' &&
        !new Decimal(normalizeDecimal(state)).gt(
            new Decimal(schema.greater_than)
        )
    ) {
        return {
            message: 'errors.validation.greaterThan',
            values: { greaterThan: schema.greater_than },
        }
    }
    if (
        typeof schema.less_or_equal !== 'undefined' &&
        !new Decimal(normalizeDecimal(state)).lte(
            new Decimal(schema.less_or_equal)
        )
    ) {
        return {
            message: 'errors.validation.lessOrEqual',
            values: { lessOrEqual: schema.less_or_equal },
        }
    }
    if (
        typeof schema.less_than !== 'undefined' &&
        !new Decimal(normalizeDecimal(state)).lt(new Decimal(schema.less_than))
    ) {
        return {
            message: 'errors.validation.lessThan',
            values: { lessThan: schema.less_than },
        }
    }
}

const doubleErrors = (state: any, schema: any): IErrMsg | undefined => {
    if (schema.is_required && !state) {
        return { message: 'errors.validation.fieldRequired' }
    }
    if (String(state).includes('e')) {
        return { message: 'errors.validation.numbersOnly' }
    }
    if (state != null && state > Number.MAX_SAFE_INTEGER) {
        return {
            message: 'errors.validation.greaterThanMaxSafeInt',
        }
    }
    if (state != null && state < Number.MIN_SAFE_INTEGER) {
        return {
            message: 'errors.validation.lessThanMinSafeInt',
        }
    }
    if (
        typeof schema.greater_or_equal !== 'undefined' &&
        Number(state) < schema.greater_or_equal
    ) {
        return {
            message: 'errors.validation.greaterOrEqual',
            values: { greaterOrEqual: schema.greater_or_equal },
        }
    }
    if (
        typeof schema.greater_than !== 'undefined' &&
        Number(state) <= schema.greater_than
    ) {
        return {
            message: 'errors.validation.greaterThan',
            values: { greaterThan: schema.greater_than },
        }
    }
    if (
        typeof schema.less_or_equal !== 'undefined' &&
        Number(state) > schema.less_or_equal
    ) {
        return {
            message: 'errors.validation.lessOrEqual',
            values: { lessOrEqual: schema.less_or_equal },
        }
    }
    if (
        typeof schema.less_than !== 'undefined' &&
        Number(state) >= schema.less_than
    ) {
        return {
            message: 'errors.validation.lessThan',
            values: { lessThan: schema.less_than },
        }
    }
    if (
        typeof schema.precision !== 'undefined' &&
        String(state).split('.')?.[1]?.length >= Number(schema.precision)
    ) {
        return {
            message: 'errors.validation.precision',
            values: { precision: schema.precision },
        }
    }
    if (state) {
        return { message: 'Invalid value' }
    }
}
